import React from 'react';
import { Modal, Button, Rate } from 'antd';
import { openNotification } from '../../util/notificaciones';
import Pedidos from '../../services/Pedidos';

/**
 * Clase para ver el proceso al planear un pedido
 */
export default class CalificarPedido extends React.Component {
    state = {
        mostrarModalConfirm: false,
        cargando: false,
        bloquearBtn: false,
        valueStars: 5,
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        if ((this.props.pedido_selected !== prevProps.pedido_selected)) {
            this.valueStars = this.props.pedido_selected?.calificacion_pedido === null ? 5 : this.props.pedido_selected?.calificacion_pedido;
            this.bloquearBtn = this.props.pedido_selected?.calificacion_pedido === null ? false : true;

            this.setState({ valueStars: this.valueStars, bloquearBtn: this.bloquearBtn });
        }
    }

    /**
     * Función que se manda a llamar cuando cambia el valor
     * de las estrellas al calificar
     */
    handleChangeStars = (value) => {
        this.setState({ valueStars: value })
    }

    /**
     * Función que se manda a llamar cuando se va a calificar
     * al proveedor
     */
    calificarPedido = () => {
        let state = { ...this.state }
        state.bloquearBtn = true;
        this.setState(state, () => {
            Pedidos.CalificarPedidoRealizado(this.props.pedido_selected.id, { calificacion_servicio: state.valueStars })
                .then(response => {
                    this.setState({ bloquearBtn: true });
                    this.props.calificarPedido(response.data.pedido);
                    state.mostrarModalCalificar = false;
                    openNotification("El nivel de servicio ha sido calificado correctamente.", "Servicio calificado", true);
                }).catch(err => {
                    this.setState({ bloquearBtn: false })
                    openNotification("Ocurrió un error al calificar el nivel de servicio.", "Error al calificar", false);
                })
        })
    }

    render() {
        return (
            <div>
                <Modal
                    title={
                        this.props.pedido_selected !== null ? 
                        "Calificar nivel de servicio del proveedor " + (["Drive"].includes(localStorage.getItem("role")) ? this.props.pedido_selected.sitio_proveedor_nombre : "")
                        : ""
                    }
                    onCancel={this.props.esconderModalCalificar}
                    visible={this.props.visible}
                    width={"45%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                className="btnCancelar"
                                key="back"
                                onClick={this.props.esconderModalCalificar}>
                                Regresar
                            </Button>,

                            <Button
                                className="btnVerCrearGuardar"
                                key="submit"
                                type="primary"
                                disabled={this.state.bloquearBtn}
                                onClick={() => {
                                    this.calificarPedido();
                                }}
                            >
                                Calificar
                    </Button>
                        ]
                    }
                >
                    <Rate
                        defaultValue={5}
                        value={this.state.valueStars}
                        allowClear={false}
                        className="stars-rate"
                        onChange={this.handleChangeStars}
                    />
                </Modal>
            </div>
        )
    }
}